export const NOTE_LIST_TYPE = {
    STRENGTHS: 'strengths',
    THREATS: 'threats',
    OPPORTUNITIES: 'opportunities',
    WEAKNESSES: 'weaknesses'
};
